import React from 'react';
import './Home.css';
import Courses from '../Courses/Courses';

function Home() {
  return (
    <div className="home-container">
      <Courses />
    </div>
  );
}

export default Home;
